module.exports = __webpack_public_path__ + "static/media/icon_canalisation.f4ae6276.svg";